// extracted by mini-css-extract-plugin
module.exports = {"trigger":"HoverTooltip_trigger__P807I","tooltip":"HoverTooltip_tooltip__HIN0K"};